import { SourcedCandidateStatus } from 'generated-graphql/types';
import {
  SOURCING_STATUS,
  SOURCING_STATUS_MESSAGES
} from 'modules/sourcing-shared/utils/mapSourcingStatuses';

export type SourcingStatusFilter = SOURCING_STATUS | 'CANDIDATE_APPLIED';

export const sourcingStatusFilterOptions = [
  {
    value: 'CANDIDATE_APPLIED',
    label: 'Candidate applied'
  },
  {
    value: 'CHECKING_PROFILE',
    label: SOURCING_STATUS_MESSAGES.CHECKING_PROFILE
  },
  {
    value: 'INVITE_SENT',
    label: SOURCING_STATUS_MESSAGES.INVITE_SENT
  },
  {
    value: 'DUPLICATE',
    label: SOURCING_STATUS_MESSAGES.DUPLICATE
  },
  {
    value: 'INVITE_FAILED',
    label: SOURCING_STATUS_MESSAGES.INVITE_FAILED
  }
];

export const getSourcedCandidateStatusesFromFilter = (
  filter: SourcingStatusFilter
): SourcedCandidateStatus[] => {
  switch (filter) {
    case 'CHECKING_PROFILE':
      return [
        SourcedCandidateStatus.Enriching,
        SourcedCandidateStatus.AwaitingInvite,
        SourcedCandidateStatus.EnrichmentSuccess,
        SourcedCandidateStatus.AwaitingEnrichment
      ];
    case 'INVITE_SENT':
      return [SourcedCandidateStatus.Invited];
    case 'DUPLICATE':
      return [SourcedCandidateStatus.Duplicate];
    case 'INVITE_FAILED':
      return [SourcedCandidateStatus.EnrichmentFailed];
    case 'CANDIDATE_APPLIED':
      return [];
  }
};
